import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { initSentry, initAuth } from '@trinity/utils'

const sentryDsn = 'https://b34f146efe3c8085a035958806a6a15f@o170893.ingest.us.sentry.io/4507108043915264'
const sentryRelease = `dealer@${__APP_VERSION__}`
initSentry(sentryDsn, sentryRelease)

initAuth()

React.startTransition(() => {
  hydrateRoot(
    document,
    <React.StrictMode>
      <HydratedRouter />
    </React.StrictMode>,
  )
})
